import type { ModuleDefinition } from '../types';

export const facilitiesModule: ModuleDefinition = {
  key: 'facilities',
  milestone: 'M8',
  network: {
    path: 'facilities',
    permission: ['network.read', 'site.read', 'study.network.read'],
    labelKey: 'facilities',
  },
  tenant: { path: 'facilities', permission: 'room.read', labelKey: 'facilities' },
  load: () => import('./FacilitiesModule'),
};
